const startOfWeekSunday = (date) => {
  const d = new Date(date);
  const day = d.getDay(); // 0=Sun..6=Sat
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - day);
  return d;
};

const endOfWeekSaturday = (date) => {
  const start = startOfWeekSunday(date);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  return end;
};

const formatMdy = (date) => {
  const m = date.getMonth() + 1;
  const d = date.getDate();
  const y = date.getFullYear();
  return `${m}/${d}/${y}`;
};

export const buildForecastUploadTemplateCsv = ({ numberOfWeeks = 8, now = new Date() } = {}) => {
  // Backend parses week columns by DateTime.TryParse(header).
  // Validation requires weeks strictly after the current week.
  // Using next week's Saturday (week-ending date) matches existing export headers style.
  const currentWeekEnd = endOfWeekSaturday(now);
  const firstValidWeekEnd = new Date(currentWeekEnd);
  firstValidWeekEnd.setDate(currentWeekEnd.getDate() + 7);

  const headers = ['Product', 'Distributor', 'BBC SKU', 'Customer'];
  for (let i = 0; i < numberOfWeeks; i++) {
    const weekEnd = new Date(firstValidWeekEnd);
    weekEnd.setDate(firstValidWeekEnd.getDate() + (i * 7));
    headers.push(formatMdy(weekEnd));
  }

  return `${headers.join(',')}\n`;
};

